import { RootState, useAppSelector } from "../../../../src/app/store";
import ActionButtonV2 from "../../../../src/components/ui/button/v2/ActionButton";
import { cn } from "../../../../src/lib/utils";
import React from "react";
import DocumentTooltip from "../../documentManagement/components/DocumentTooltip";



interface FeatureGateActionButtonProps {
  text: string;
  icon?: React.ReactNode;
  onClick: () => void;

  selector: (state: RootState) => boolean;
  disabledMessage?: string;

  variant?: "primary" | "secondary" | "ai-gradient";
  size?: "sm" | "md" | "lg";
  className?: string;
}

const FeatureGateActionButton: React.FC<FeatureGateActionButtonProps> = ({
  text,
  icon,
  onClick,
  selector,
  disabledMessage,
  variant = "secondary",
  size = "md",
  className,
}) => {
  const isEnabled = useAppSelector(selector);
  const isDisabled = !isEnabled; 

  const button = (
    <ActionButtonV2
      text={text}
      icon={icon}
      onClick={onClick}
      disabled={isDisabled}
      variant={variant}
      size={size}
      className={cn("disabled:opacity-100", className)}
    />
  );

  if (isDisabled) {
    return (
      <DocumentTooltip content={disabledMessage || "Not available"}>
        <span className="inline-flex">{button}</span>
      </DocumentTooltip>
    );
  }

  return button;
};

export default FeatureGateActionButton;
